export default {
  settingInfo: null,
  systemInfo: null
}
